/* Project Import will be here */
import { getOrderPendingInvListApi, updateInvDeliveredApi } from "services/orders";
import { IOrderInvStatusUpdateParams } from "models/orderModels";
import { showMsgFromJson } from "reducers/common";
import { getErrorObject, errorToast } from "utilities/utils";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    ORDER_PENDING_INV_LIST_REQUEST: "orderStatusDelivery/orderPendingInvListRequest",
    ORDER_PENDING_INV_LIST_SUCCESS: "orderStatusDelivery/orderPendingInvListSuccess",
    ORDER_PENDING_INV_LIST_FAILURE: "orderStatusDelivery/orderPendingInvListFailure",
    UPDATE_INV_STATUS_REQUEST: "orderStatusDelivery/updateInvStatusRequest",
    UPDATE_INV_STATUS_SUCCESS: "orderStatusDelivery/updateInvStatusSuccess",
    UPDATE_INV_STATUS_FAILURE: "orderStatusDelivery/updateInvStatusFailure"
};

let initialState = {
    isLoading: false,
    updateInvStatusIsLoading: false,
    data: [],
    error: null
};

export const orderStatusDelivery = (state = initialState, action) => {
    switch (action.type) {
        case types.ORDER_PENDING_INV_LIST_REQUEST:
            return { ...state, isLoading: true };
        case types.ORDER_PENDING_INV_LIST_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.ORDER_PENDING_INV_LIST_FAILURE:
            return { ...state, data: [], isLoading: false, error: action.payload.error };

        case types.UPDATE_INV_STATUS_REQUEST:
            return { ...state, updateInvStatusIsLoading: true };
        case types.UPDATE_INV_STATUS_SUCCESS:
            return { ...state, error: null, updateInvStatusIsLoading: false };
        case types.UPDATE_INV_STATUS_FAILURE:
            return { ...state, updateInvStatusIsLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

/* Get pending inv list to show in the card */
export const getOrderPendingInvList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.ORDER_PENDING_INV_LIST_REQUEST });
        try {
            const response = await getOrderPendingInvListApi();

            dispatch({
                type: types.ORDER_PENDING_INV_LIST_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.ORDER_PENDING_INV_LIST_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Update non delivered inv to delivered */
export const updateInvDelivered = (data: IOrderInvStatusUpdateParams) => {
    return async (dispatch, getState) => {        
        dispatch({ type: types.UPDATE_INV_STATUS_REQUEST });
        try {
            await updateInvDeliveredApi(data);

            dispatch({ type: types.UPDATE_INV_STATUS_SUCCESS });

            /* Inv status update success toast */
            dispatch(showMsgFromJson("common.alerts.success.InvStatusUpdateSuccess", Constants.SUCCESS));

            /* Re initialize order state */
            dispatch(getOrderPendingInvList());
        }
        catch (error) {
            /* Extract the error message and error code from the response object */
            const { message, errorCode } = getErrorObject(error);

            dispatch({
                type: types.UPDATE_INV_STATUS_FAILURE,
                payload: { error: message }
            });

            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};